import type { CSVMapping, CSVFileName } from '../types/etl.types'

export const CSV_MAPPINGS: Record<CSVFileName, CSVMapping> = {
  'ESPECIES_CATALOGO.csv': {
    targetTable: 'especies',
    requiredColumns: ['codigo_especie', 'nombre_cientifico'],
    mapping: {
      'codigo_especie': 'codigo_especie',
      'nombre_cientifico': 'nombre_cientifico',
      'nombre_comun': 'nombre_comun',
      'tipo_vegetacion': 'tipo_vegetacion',
      'descripcion': 'descripcion',
    },
  },

  'CODIGOS_INE_municipios.csv': {
    targetTable: 'municipios',
    requiredColumns: ['ID', 'NOMBRE'],
    mapping: {
      'ID': 'id_municipio',
      'NOMBRE': 'nombre',
    },
  },

  'Existencias_Muni_BMP_4.csv': {
    targetTable: 'existencias_forestales',
    requiredColumns: ['IDmuni', 'Especie', 'CD'],
    mapping: {
      'IDmuni': 'id_municipio',
      'Especie': 'codigo_especie',
      'CD': 'clase_diametrica',
      'NPies_sum': 'num_pies',
      'ABas_sum': 'area_basal',
      'VCC_sum': 'volumen_corteza',
      'VSC_sum': 'volumen_sin_corteza',
      'IAVC_sum': 'incremento_anual',
      'VLE_sum': 'volumen_lena',
      'BA_sum': 'biomasa_aerea',
      'BR_sum': 'biomasa_raiz',
      'CA_sum': 'carbono_aereo',
      'CR_sum': 'carbono_raiz',
    },
  },

  'MFE25_FormArb.csv': {
    targetTable: 'formaciones_municipales',
    requiredColumns: ['IDmuni', 'FORARB', 'Area_ha'],
    mapping: {
      'IDmuni': 'id_municipio',
      'FORARB': 'codigo_formacion',
      'FormArbNOM': 'nombre_formacion',
      'Area_ha': 'area_hectareas',
      'Perc': 'porcentaje_cobertura',
      'ESTRATOIFN': 'estrato_ifn',
    },
  },

  'MFE25_FormHerb.csv': {
    targetTable: 'formaciones_herbaceas',
    requiredColumns: ['IDmuni', 'Area_ha'],
    mapping: {
      'IDmuni': 'id_municipio',
      'FormHerbac': 'tipo_herbaceo',
      'Area_ha': 'area_hectareas',
      'Porc': 'porcentaje',
      'FCC_Form': 'descripcion',
    },
  },

  'MFE25_FormMato.csv': {
    targetTable: 'formaciones_matorral',
    requiredColumns: ['IDmuni', 'Area_ha'],
    mapping: {
      'IDmuni': 'id_municipio',
      'FormArbust': 'tipo_matorral',
      'Area_ha': 'area_hectareas',
      'Perc': 'porcentaje',
      'n_FORmat': 'descripcion',
    },
  },

  'Prop_BMP_Mun.csv': {
    targetTable: 'propiedades_forestales',
    requiredColumns: ['IDmuni'],
    mapping: {
      'IDmuni': 'id_municipio',
      'ADMON': 'tipo_administracion',
      'TITULAR': 'titular',
      'NUM_MONTE': 'numero_monte',
      'Propiedad': 'tipo_propiedad',
      'Sup_ha': 'superficie_hectareas',
    },
  },

  'BMP_ExsMuniIFN2.csv': {
    targetTable: 'inventarios_ifn2',
    requiredColumns: ['IDmuni', 'Especie', 'CD'],
    mapping: {
      'IDmuni': 'id_municipio',
      'Especie': 'codigo_especie',
      'CD': 'clase_diametrica',
      'N_IFN2': 'num_pies',
      'AB_IFN2': 'area_basal',
      'VCC_IFN2': 'volumen_corteza',
      'VSC_IFN2': 'volumen_sin_corteza',
      'VLE_IFN2': 'volumen_lena',
    },
  },

  'BMP_ExsMuniIFN3.csv': {
    targetTable: 'inventarios_ifn3',
    requiredColumns: ['IDmuni', 'Especie', 'CD'],
    mapping: {
      'IDmuni': 'id_municipio',
      'Especie': 'codigo_especie',
      'CD': 'clase_diametrica',
      'N_IFN3': 'num_pies',
      'AB_IFN3': 'area_basal',
      'VCC_IFN3': 'volumen_corteza',
      'VSC_IFN3': 'volumen_sin_corteza',
      'VLE_IFN3': 'volumen_lena',
    },
  },

  'MFE25_LULUCF.csv': {
    targetTable: 'lulucf',
    requiredColumns: ['IDmuni', 'LULUCF'],
    mapping: {
      'IDmuni': 'id_municipio',
      'LULUCF': 'codigo_lulucf',
      'Area_ha': 'area_hectareas',
      'Porc': 'porcentaje',
    },
  },

  'MFE25_ModCom.csv': {
    targetTable: 'modelos_combustible',
    requiredColumns: ['IDmuni', 'n_MODCOM'],
    mapping: {
      'IDmuni': 'id_municipio',
      'n_MODCOM': 'modelo_combustible',
      'ModeloComb': 'descripcion',
      'Area_ha': 'superficie_hectareas',
      'Porc': 'riesgo_incendio',
    },
  },

  'MFE50_FormacionesArboladas_Mun.csv': {
    targetTable: 'formaciones_arboladas_50k',
    requiredColumns: ['IDmuni', 'NOM_FORARB'],
    mapping: {
      'IDmuni': 'id_municipio',
      'NOM_FORARB': 'nombre_formacion',
      'sup_ha': 'area_hectareas',
    },
  },

  'ValorMUNI_BMP.csv': {
    targetTable: 'valoraciones_economicas',
    requiredColumns: ['IDmuni', 'FormArbNAME', 'Area_ha'],
    mapping: {
      'IDmuni': 'id_municipio',
      'FormArbNAME': 'formacion_arbolada',
      'Area_ha': 'area_hectareas',
      'Alimentos': 'valor_alimentos',
      'Madera': 'valor_madera',
      'Leña': 'valor_lena',
      'Pastos': 'valor_pastos',
      'Agua': 'valor_agua',
      'Recreativo': 'valor_recreativo',
      'Caza': 'valor_caza',
      'SedimentaEvitaEmbalses': 'valor_sedimentacion',
      'CarbonoSupForestal': 'valor_carbono_suelo',
      'CarbonoArbolado': 'valor_carbono_arbolado',
      'CarbonoMatorral': 'valor_carbono_matorral',
      'DiversidadBiologica': 'valor_biodiversidad',
    },
  },

  'CalidadesMUNI.csv': {
    targetTable: 'calidades_forestales',
    requiredColumns: ['IDmuni', 'Calidad', 'VCC_m3_ha'],
    mapping: {
      'IDmuni': 'id_municipio',
      'Calidad': 'calidad_estacion',
      'VCC_m3_ha': 'volumen_medio',
    },
  },
}

export function getCSVConfig(fileName: string): CSVMapping | null {
  return CSV_MAPPINGS[fileName as CSVFileName] || null
}

export function isValidCSVFile(fileName: string): boolean {
  return fileName in CSV_MAPPINGS
}

export const CSV_FILES_INFO = [
  { name: 'ESPECIES_CATALOGO.csv', records: 36, description: 'Catálogo de especies forestales' },
  { name: 'CODIGOS_INE_municipios.csv', records: 191, description: 'Catálogo de municipios' },
  { name: 'Existencias_Muni_BMP_4.csv', records: 6766, description: 'Existencias forestales' },
  { name: 'MFE25_FormArb.csv', records: 640, description: 'Formaciones arboladas' },
  { name: 'MFE25_FormHerb.csv', records: 347, description: 'Formaciones herbáceas' },
  { name: 'MFE25_FormMato.csv', records: 554, description: 'Formaciones matorral' },
  { name: 'Prop_BMP_Mun.csv', records: 128054, description: 'Propiedades forestales (archivo más grande)' },
  { name: 'BMP_ExsMuniIFN2.csv', records: 1528, description: 'Inventario Forestal Nacional 2' },
  { name: 'BMP_ExsMuniIFN3.csv', records: 4019, description: 'Inventario Forestal Nacional 3' },
  { name: 'MFE25_LULUCF.csv', records: 832, description: 'Clasificación LULUCF' },
  { name: 'MFE25_ModCom.csv', records: 628, description: 'Modelos de combustible' },
  { name: 'MFE50_FormacionesArboladas_Mun.csv', records: 637, description: 'Formaciones arboladas 1:50k' },
  { name: 'ValorMUNI_BMP.csv', records: 549, description: 'Valoraciones económicas' },
  { name: 'CalidadesMUNI.csv', records: 206, description: 'Calidades forestales' },
] as const
